// extracted by mini-css-extract-plugin
export default {"modalImgHeight":"jTOcoVzr551yfx3Arh8R__modalImgHeight___"};